<template>
  <div>
    <div class="layer-toggle-container">
      <x-img :src="layer.img" data-test="layer-thumbnail" />
      <!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
      <label :for="layer.id" data-test="layer-label">
        <ys-text type="title5">{{ layer.label }}</ys-text>
        <ys-text type="metadata1">{{ layer.byline }}</ys-text>
      </label>
      <ys-switch
        v-if="layer.hasAccess"
        :id="layer.id"
        :selected="layer.active"
        :data-test="`${layer.id}-toggle`"
        @change="toggleLayer($event.target.selected)"
      />
      <span v-else class="lock">
        <x-icon
          icon="lock"
          color="white"
          width="15"
          height="15"
          data-test="lock"
        />
      </span>
    </div>
    <hr />
    <button class="more-details-container" @click="$emit('open-layer-details')">
      <ys-text type="body1">Layer Details</ys-text>
      <ys-icon icon="ysChevronRight" size="small" />
    </button>
  </div>
</template>
<!-- eslint-disable vue/block-lang -->
<script setup>
import { computed } from 'vue'
import '@onxmaps/yellowstone-ui/ys-text'
import '@onxmaps/yellowstone-ui/ys-icon'
import '@onxmaps/yellowstone-ui/icons/ysChevronRight'
import '@onxmaps/yellowstone-ui/ys-switch'

import xIcon from '@/components/shared/x-icon'
import xImg from '@/components/shared/x-img'
import layerService from '@/services/layer-service'
import marketingEventService from '@/services/marketing-event-service'
import { basemapMarketingName } from '@/services/basemap-service'
import { CARD_ORIGINS } from '@/lib/enums-marketing'
import { getMode } from '@/lib/modes'

const props = defineProps({
  layer: {
    type: Object,
    required: true,
  },
  eventOrigin: {
    type: String,
    required: false,
    default: CARD_ORIGINS.BASEMAP,
  },
})

const emit = defineEmits(['open-layer-details', 'toggle'])

const mapMode = computed(getMode)
const toggleLayer = (toggleState) => {
  layerService.toggleLayer(props.layer.id)
  const layerState = toggleState ? 'enabled' : 'disabled'
  marketingEventService.publish(`layer_${layerState}`, {
    name: `layer_${layerState}`,
    origin: props.eventOrigin,
    layer_name: props.layer.label,
    map_mode: mapMode.value,
    active_basemap: basemapMarketingName.value,
  })
  emit('toggle', props.layer, toggleState)
}
</script>
<style lang="scss" scoped>
.layer-toggle-container {
  display: flex;
  justify-content: space-between;
  gap: 16px;

  label {
    flex-grow: 2;
  }

  h5 {
    margin-bottom: 3px;
  }

  img {
    width: 48px;
    height: 48px;
    border-radius: 8px;
  }

  .lock {
    border-radius: 50%;
    min-width: 30px;
    height: 30px;
    background-color: var(--ys-color-icon-twotone-primary);
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

hr {
  margin: 8px 0px 10px 64px;
}

.more-details-container {
  all: unset;
  width: -webkit-fill-available;
  margin-left: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}
</style>
